<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="user-settings__top">
        <div class="user-settings__profil" style="width: 100%;display: flex; justify-content: space-between;">
          <div class="left-one" style="display: flex; align-items: center;">
            <div class="left">
              <img src="@/assets/img/campuscity-logo.png" alt="" class="user-settings__profil-img"></div>
            <div class="right" style="margin-left: -45px;"><p class="user-settings__profil-name">
              Welcome ! </p>
              <p class="user-settings__profil-mail">
                {{first_name}} {{last_name}}
              </p></div>
          </div>
          <div class="right">
            <p class="user-settings__profil-name mail">
              {{mail1}}
              <span class="sign-out">
                <svg class="icon"><use
                  xlink:href="/icon/icons.svg#icon-mail"></use>
                </svg>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="user__list-offer" style="margin-top: 40px;">
        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">MOVIE INFORMATION</div>
          <div class="register-box_input">
            <v-input placeholder="Original Title" v-model="name"/>
            <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label>
            <v-input placeholder="Description" class="textarea" v-model="keywords"/> 
            <div class="groups">
              <v-select :options="cities" placeholder="Select Genre" v-model="city_id" style="font-weight: bold" @onselect="selectCity" />
              <v-select :options="districts" placeholder="Select Company" @onselect="selectDistrict"/>
              <v-select class="big-select" :options="genders" placeholder="Movie Type" style="width: 225%;margin-right: 0;" v-model="video_type" @onselect="selectGender" />
            </div>

            <div class="groups">
              <v-input placeholder="E-Mail Address" style="width: 47%" v-model="email"/>
              <label for="password" v-if="falseEmail" class="myValidationText">Wrong e-mail format!</label>
              <label for="password" v-if="emptyEmail" class="myValidationText">Can not be leave empty!</label> 
              <v-input placeholder="Telephone" style="width: 47%" v-model="phone"/>
             <label for="phone" v-if="emptyPhone2" class="myValidationText">Can not be leave empty!</label>
             <label for="phone" v-if="falsePhone2" class="myValidationText">Phone number must start with 0!</label>
             <label for="phone" v-if="shortPhone2" class="myValidationText">Phone number must be 11 digits!</label>              
            </div>
            <v-input placeholder="Address" v-model="address"/>
          <label for="password" v-if="emptyAddress" class="myValidationText">Can not be leave empty!</label>  
          <v-input placeholder="Mesaj İçin Telefon" style="width: 47%" v-model="message_phone"/>
             <label for="phone" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
             <label for="phone" v-if="falsePhone" class="myValidationText">Phone number must start with 0!</label>
             <label for="phone" v-if="shortPhone" class="myValidationText">Phone number must be 11 digits!</label> 
        <v-input placeholder="Web Adresi" style="width: 47%" v-model="web"/>

<p>&nbsp;</p>
<p>&nbsp;</p>
</div>
<!-- <label>Logo Fotoğrafı</label>
        <MyDormGaleriLogo :gallery="imagesLogo"/>
<label>Kapak Fotoğrafı</label>
        <MyDormGaleriCover :gallery="imagesCover"/> -->
<div>
<p>&nbsp;</p>
<p>&nbsp;</p>
</div>
          </div>
        </div>
<div>
        <div class="register-box__info col-xl-12">
          <div class="or blue">
            <p class="or__title-blue">MOVIE PRODUCERS</p>
          </div>
          <v-input placeholder="Director" v-model="member"/>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <v-input placeholder="Producer" v-model="member_email"/>
            </div>

            <div class="col-xs-12 col-md-6">
              <v-input placeholder="Director Email" v-model="mobile_phone"/>
             <label for="phone" v-if="emptyPhone3" class="myValidationText">Can not be leave empty!</label>
             <label for="phone" v-if="falsePhone3" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
             <label for="phone" v-if="shortPhone3" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>               
            </div>
          </div>
        </div>

        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">SUMMARY</div>
          <div class="register-box_input">
            <v-input placeholder="Description in Original Language" class="textarea" v-model="content"/>
            <v-input placeholder="Description in English" class="textarea" v-model="content_en"/>
            <div class="groups">
              <!-- <v-select :options="days" placeholder="Kapasite" v-model="capacity" style="font-weight: bold"/> -->
              <v-input placeholder="Runtime (In Minutes)" v-model="capacity"/>
              <label for="password" v-if="emptyCapacity" class="myValidationText">Can not be leave empty!</label>
              <v-select :options="meals" placeholder="Video" @onselect="selectMeal"/>
              <label for="password" v-if="emptyMeal" class="myValidationText">Can not be leave empty!</label>
              <v-select :options="wifi" placeholder="Trailer" style="width: 225%;margin-right: 0;" @onselect="selectWifi" />
              <label for="password" v-if="emptyWifi" class="myValidationText">Can not be leave empty!</label>
            </div>
          </div>
        </div>

<!--         <div class="login-box register-box choose-gen col-xl-12">
          <div class="my-dorm__title">ODA TİPLERİ</div>
          <div class="room-type">
              <my-dorm-room-type/>
          </div>
        </div> -->

        <div class="login-box register-box choose-gen col-xl-12">
          <div class="my-dorm__title">GENRES MOVIE BELONGS</div>
<!--           <div class="room-type">
            <div >
              <MyDormBuildingServices/>
            </div>
          </div>
          <div class="room-type">
            <div >
              <my-dorm-room-services/>
            </div>
          </div> -->
          <div class="room-type">
            <div >
              <MyDormServices :bina="bina" :oda="oda" :hizmetler="hizmetler"/>
            </div>
          </div>             
        </div>
      </div>


<!--         <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">MAP INFORMATION</div>
          <div class="register-box_input">
            <v-input placeholder="Enlem" class="textarea" v-model="lat"/>
            <v-input placeholder="Boylam" class="textarea" v-model="lng"/>
          </div>
        </div>  -->

        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">MULTIMEDIA</div>
          <div class="register-box_input">
              <v-select class="big-select" :options="videotypes" placeholder="Video Type" style="width: 25%;margin-right: 0;" v-model="type_id" @onselect="selectVideo" />            
            <v-input placeholder="Video Url" class="textarea" v-model="video_url"/>
            <v-input placeholder="Youtube" class="textarea" v-model="virtual_tour"/>
          </div>
        </div> 

<!--         <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">GENEL BİLGİLER</div>
          <div class="register-box_input">
            <v-input placeholder="Tesisler" class="textarea" v-model="facilities"/>
            <v-input placeholder="Avantajlar" class="textarea" v-model="advantages"/>
            <v-input placeholder="Etkinlikler" class="textarea" v-model="events"/>
            <v-input placeholder="Ulaşım" class="textarea" v-model="transportation"/>
            <v-input placeholder="Diğer" class="textarea" v-model="advantages"/>                
          </div>
        </div> -->
      
        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">META INFORMATION</div>
          <div class="register-box_input">
            <v-input placeholder="Description" class="textarea" v-model="description"/>
            <v-input placeholder="Keywords" class="textarea" v-model="keywords"/>
          </div>
        </div>

        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">LOCATION</div>
          <div class="register-box_input">


           <label for>Neighborhood Theathers?</label>
                                    <multiselect
                                            v-model="university"
                                            tag-placeholder="Add Studio"
                                            placeholder="Search Studio"
                                            label="name"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :custom-label="nameWithUniversity"
                                            track-by="id"
                                            :options="universities"
                                            :multiple="true"
                                            :taggable="true"
                                            @tag="addTag"
                                    ></multiselect>
          </div>
        </div>

         <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">PHOTO GALLERY</div>
          <div class="register-box_input">

<div>
<p>&nbsp;</p>
<p>&nbsp;</p>
</div>
        <MyDormGaleri :gallery="images"/>
<div>
<p>&nbsp;</p>
<p>&nbsp;</p>
</div>

          </div>
        </div>

        <div class="branch-add mywidth" v-on:click="saveDorm()" v-if="messageEnabled">
          <button class="branch-add__button">
            <p class="branch-add__txt">SAVE</p>
            <span class="branch-add__icon">
              <svg-icon type="icon-plus"/>
            </span>
          </button>        
        </div>
        <div class="branch-add mywidth" v-if="!messageEnabled">
          <button class="branch-add__button">
            <p class="branch-add__txt">SAVING</p>
            <span class="branch-add__icon">
              <svg-icon type="icon-plus"/>
            </span>
          </button>        
        </div>        
    </container>
   <div>
   </div>
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >MOVIE ADDED!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">The movie is saved in our system.</span></p>
      <p ><span class= "mycolorBlue">You can update the movie whenever you want.</span></p>
    </div>
     </div>
</div>
</Modal2>
<Modal2 :active="showErrorMessage" @onModalClose="closeModal3">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title2" >MOVIE COULD NOT ADDED!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Unfotunately  şu anda şube eklenemedi</span></p>
      <p ><span class= "mycolorBlue">Lütfen daha sonra tekrar deneyin.</span></p>
    </div>
     </div>
</div>
</Modal2> 
  </div>
</template>

<script>
import MyDormGaleri from '@/components/MyDormGaleri2'
import MyDormGaleriLogo from '@/components/MyDormGaleriLogo'
import MyDormGaleriCover from '@/components/MyDormGaleriCover'
import MyDormRoomType from '@/components/MyDormRoomType'
import MyDormServices from '@/components/MyDormServices'
import Modal2 from '@/components/Modal2'
import Multiselect from "vue-multiselect";
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'DormUserDormDetail',
  components: {
    MyDormGaleri, MyDormServices, Modal2, MyDormRoomType, MyDormGaleriLogo, MyDormGaleriCover, Multiselect
  },
  data () {
    return {
      messageEnabled: true,
      showSuccessMessage: false,
      showErrorMessage: false,
      faculties: [],
      university: [],
      universities: [],
      imagesLogo: [],
      imagesCover: [],
      images: [],
      errors: [],
      bina: [
        {
          title: 'Action',
          id: 1,
          selected: false
        },
        {
          title: 'Adventure',
          id: 2,
          selected: false
        },
        {
          title: 'Animation',
          id: 3,
          selected: false
        },
        {
          title: 'Comdey',
          id: 4,
          selected: false
        },
        {
          title: 'Crime',
          id: 6,
          selected: false
        },
        {
          title: 'Documentary',
          id: 8,
          selected: false
        }
      ],
      oda: [
        {
          title: 'Drama',
          id: 19,
          selected: false
        },        
        {
          title: 'Family',
          id: 5,
          selected: false
        },
        {
          title: 'Fantasy',
          id: 9,
          selected: false
        },
        {
          title: 'History',
          id: 10,
          selected: false
        },
        {
          title: 'Horror',
          id: 11,
          selected: false
        },
        {
          title: 'Music',
          id: 12,
          selected: false
        }      
      ],
      hizmetler: [
        {
          title: 'Mystery',
          id: 13,
          selected: false
        },
        {
          title: 'Romance',
          id: 22,
          selected: false
        },        
        {
          title: 'Science Fiction',
          id: 16,
          selected: false
        },
        { 
          title: 'Thriller',
          id: 18,
          selected: false
        },
        {
          
          title: 'War',
          id: 20,
          selected: false
        },
        {
          title: 'Western',
          id: 21,
          selected: false
        }      
      ],
      video_type: null,
      video_url: null,
      virtual_tour: null,
      mail: null,
      emptyName: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      falsePhone2: false,
      shortPhone2: false,
      emptyPhone2: false,
      falsePhone3: false,
      shortPhone3: false,
      emptyPhone3: false,      
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyAddress: false,
      emptyCapacity: false,
      emptyMeal: false,
      emptyWifi: false,      
            props: [],
            //props.*: [],
            cities: [],
            districts: [],
            faculties: [],
            type_id: 1,
            city_id: null,
            district_id: null,
            name: '',
            slug: '',
            keywords: '',
            description: '',
            member:'',
            member_email: '',
            member_phone: '',
            capacity: null,
            is_wifi: null, //undefined','
            meal: null, //undefined',
            content: '',// undefined',
            content_en: '', //undefined',
            facilities:null, //undefined',
            advantages: null, //undefined',
            events:null, //undefined',
            transportation:null, //undefined',
            other:null, //undefined',
            phone: null, //regex:/(0)[0-9]{10}/|not_in:null,undefined',
            mobile_phone: '', //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            message_phone: '', //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            fax: '',
            email:'',
            web: '' , //undefined',
            address: '', //' => 'required|not_in:null,undefined',
            lat: '', //undefined',
            lng: '', //undefined',
            note: '',
            
      links: [
        {
          id: 0,
          title: 'İstatistik Özeti',
          to: '/yurtlar-istatistik'
        },
        {
          id: 1,
          title: 'Bilgilerim',
          to: '/yurt-hesap-bilgileri'
        },
        {
          id: 2,
          title: 'Rezervasyonlar',
          to: '/kullanici-teklifler'
        },
        {
          id: 3,
          title: 'Mesajlar',
          to: '/mesaj-liste'
        },
        {
          id: 4,
          title: 'Yurtlarım',
          to: '/yurt-sube'
        },
        {
          id: 5,
          title: 'İlanlarım',
          to: '/kullanici-favoriler'
        },
        {
          id: 6,
          title: 'Yorumlar',
          to: '/yurtlar-yorumlar'
        }
      ],
      days: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days1: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days2: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      videotypes: [
        {
          name: 'Youtube',
          id: '1',
        },
        {
          name: 'Vimeo',
          id: '2',
        }
      ],      
      genders: [
        {
          name: 'No Adult',
          id: '1',
          selected: false
        },
        {
          name: 'Adult',
          id: '2',
          selected: false
        }
      ],
      meals: [
        {
          name: 'Yes',
          id: '1',
          selected: false
        },
        {
          name: 'No',
          id: '2',
          selected: false
        }      
      ],
      wifi: [
        {
          name: 'Have Trailer',
          id: '1',
          selected: false
        },
        {
          name: 'No Trailer',
          id: '2',
          selected: false
        }
      ]                    
    }
  },
  computed: {
    ...mapGetters(['first_name', 'last_name', 'phone', 'mail1'])
  },  
  methods: {
    getData() {
      this.axios.get("dorms/create").then(response => {
                   // this.users = response.data.users;
                   // this.cities = response.data.cities;
                   // this.properties = response.data.properties;
                    this.universities = response.data.universities;
                    // console.log(this.universities);
       });
    },    
    nameWithUniversity({name, university}) {
       if (university) {
         return `${name} — (${university.name})`;
       }
       return name;
    },    
    addTag(newTag) {
      const tag = {
          name: newTag,
            id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
                };
        this.universities.push(tag);
        this.university.push(tag.id);
    },    
    closeModal2() {
      this.showSuccessMessage = false
    },
    closeModal3() {
      this.showErrorMessage = false
    }, 
    validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
    },    
    saveDorm () {
      const mytoken = window.localStorage.getItem('access_token')
      this.slug = this.slugify(this.name)
      let self = this
      this.falseEmail = false
      this.emptyName = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyPhone2 = false
      this.falsePhone2 = false
      this.shortPhone2 = false
      this.emptyPhone3 = false
      this.falsePhone3 = false
      this.shortPhone3 = false             
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyAddress = false
      this.emptyCapacity = false
      this.emptyMeal = false
      this.emptyWifi = false
      const verifiedMail = this.validateEmail(this.email)

      if(!this.email) {
        this.emptyEmail = true
      } else if(this.email &&! verifiedMail) {
        this.falseEmail = true
      }
      if(!this.name) {
        this.emptyName = true
      }
      if(!this.address) {
        this.emptyAddress = true
      }      
      if(!this.capacity) {
        this.emptyCapacity = true
      }
      if(!this.meal) {
        this.emptyMeal = true
      }
      if(!this.is_wifi) {
        this.emptyWifi = true
      }
      if(!this.message_phone) {
        this.emptyPhone = true
      }      
      if(this.message_phone && !this.message_phone.startsWith("0")) {
        this.falsePhone = true
      }      

      if(this.message_phone && !this.falsePhone && this.message_phone.length != 11) {
        this.shortPhone = true
      }

      if(!this.phone) {
        this.emptyPhone2 = true
      }      
      if(this.phone && !this.phone.startsWith("0")) {
        this.falsePhone2 = true
      }      

      if(this.phone && !this.falsePhone2 && this.phone.length != 11) {
        this.shortPhone2 = true
      }
      if(!this.mobile_phone) {
        this.emptyPhone3 = true
      } 
      if(this.mobile_phone && !this.mobile_phone.startsWith("0")) {
        this.falsePhone3 = true
      }      

      if(this.mobile_phone && !this.falsePhone3 && this.mobile_phone.length != 11) {
        this.shortPhone3 = true
      }

if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyPhone2 && !this.falsePhone2 && !this.shortPhone2 && !this.emptyPhone3 && !this.falsePhone3 && !this.shortPhone3 && !this.emptyAddress && !this.emptyCapacity && !this.emptyMeal && !this.emptyWifi) {
      

/*       for (let i = 0; i < this.props.length; i++) {
        formData.append("props[]", this.props[i]);
      } */


/*      

      if(this.props.length > 0) {
        for (let i = 0; i < this.props.length; i++) {
          formData.append("props[]", this.props[i]);
        }
      } */

            var data = {
                          type_id: this.type_id,
            city_id: this.city_id,
            district_id: this.district_id,
            name: this.name, //required',
            slug: this.slug, //required',
            keywords: this.keywords,
            description: this.description,
            member: self.member,
            capacity: self.capacity,
            is_wifi: self.is_wifi, //undefined',
            meal: self.meal, //undefined',
            content: this.content,// undefined',
            content_en: this.content_en, //undefined',
            facilities: '', //undefined',
            advantages: '', //undefined',
            events:'', //undefined',
            transportation: '', //undefined',
            other: '', //undefined',
            phone: this.phone, //regex:/(0)[0-9]{10}/|not_in:null,undefined',
            mobile_phone: self.mobile_phone, //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            message_phone: self.message_phone, //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            fax: self.fax,
            email: this.email,
            web: this.web, //undefined',
            address: self.address, //' => 'required|not_in:null,undefined',
            lat: this.lat, //undefined',
            lng: this.lng, //undefined',
            note: 'notum', //undefined',
            video_url: this.video_url, 
            video_type: this.video_type,
            virtual_tour: this.virtual_tour,
            cover: this.imagesCover[0],
            logo: this.imagesLogo[0]
            // display_cover: images[0]
            }
            const formData = new FormData()
                Object.keys(data).map(e => {
                    formData.append(e, data[e]);
                })
          //formData.append("video[]", this.video);

          if(this.images.length > 0) {
          for (let i = 0; i < this.images.length; i++) {
            formData.append("images[]", this.images[i]);
          }
          }/*
         for (let i = 0; i < this.bina.length; i++) {
          if(this.bina[i].selected){
            formData.append("props[]", this.bina[i].id);
          }
        }
        for (let i = 0; i < this.oda.length; i++) {
          if(this.oda[i].selected){
            formData.append("props[]", this.oda[i].id);
          }
        }*/
        for (let i = 0; i < this.hizmetler.length; i++) {
          if(this.hizmetler[i].selected){
            formData.append("props[]", this.hizmetler[i].id);
          }
        }

                if (this.university.length > 0) {
                    for (let i = 0; i < this.university.length; i++) {
                        formData.append("faculties[]", this.university[i].id);
                    }
                }      
      this.messageEnabled = false 
      axios.post("/dorm/dorms/", formData)
        .then(response => {
            if (response.status === 200 || response.status === 201) {
          self.messageEnabled = true
          self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
              self.messageEnabled = true
            }
        })
        .catch(e => {
          self.messageEnabled = true
          this.errors.push(e)
        })
}
    },
    getCities () {
      let self = this
      axios.get('/site/home/select-cities')
        .then(response => {
          self.cities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectCity (opt) {
      this.city_id = opt.id
      this.districtEnabled = true
      let self = this
      axios.get(`/site/cities/${opt.slug}`)
        .then(response => {
          self.districts = response.data.districts
        })
        .catch(e => {
          this.errors.push(e)
        }) 
    },
     selectDistrict(opt) {
       this.district_id = opt.id
     },
     selectGender(opt) {
       this.type_id = opt.id
     },
     selectVideo(opt) {
       this.video_type = opt.name
     },
     selectWifi(opt) {
       this.is_wifi = opt.id
     },
     selectMeal(opt) {
       this.meal = opt.name
     },
     slugify(string) {
      const a = 'àáäâãåăæąçćčđèéėëêęǵḧìíïîįłḿǹńňñòóöôœøṕŕřßśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
     const b = 'aaaaaaaaacccdeeeeeeghiiiiilmnnnnooooooprrssssttuuuuuuuuuwxyyzzz------'
     const p = new RegExp(a.split('').join('|'), 'g')

     return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}       
  },
  created () {
    this.email = window.localStorage.getItem('mail')
    this.username = window.localStorage.getItem('username')
    this.message_phone = window.localStorage.getItem('phone1')
    this.phone = window.localStorage.getItem('phone1')    
    this.getCities()
   // this.getData()
  } 
}

</script>
<style lang="scss">

  @import "../assets/scss/components/dormAdd";
  @import "../assets/scss/components/dorm-branch";

  .mywidth {
    width: 5px;
  }

</style>
